import { Routes as Switch, Route } from "react-router-dom";
import { ProtectedRoute } from "../../modules/auth";
import { Orders } from "../../pages/Orders";
import { System } from "../../pages/System";
import { AbilityContext } from "../../modules/casl";
import { FC, useCallback, useContext } from "react";
import { RouteNotMatch } from "../../modules/navigation";
import { Order } from "../../pages/Order";
import { ProductsPortfolio } from "../../pages/ProductsPortfolio";
import { Store } from "../../pages/Store";
import { Support } from "../../pages/Support";
import { Metadata } from "../../pages/Metadata";
import { Warranty } from "../../pages/Warranty";
import { Users } from "../../pages/Users";
import { Profile } from "../../pages/Profile";
import { HomeNoSystem } from "../../pages/HomeNoSystem";

export const Routes: FC = () => {
  const ability = useContext(AbilityContext);
  const params = "/:systemId";

  const getRouteByEnabledSystems = useCallback(
    (route: string) => {
      return `${params}${route}`;
    },
    [params]
  );
  return (
    <Switch>
      <Route path="*" element={<RouteNotMatch />} />
      <Route path="/warranty" element={<Warranty />} />
      <Route
        path="/no-system"
        element={<ProtectedRoute component={HomeNoSystem} />}
      />
      <Route
        path={getRouteByEnabledSystems("/profile")}
        element={<ProtectedRoute component={Profile} />}
      />

      {ability.can("get", "orders") ? (
        <Route
          path={`${params}/orders`}
          element={<ProtectedRoute component={Orders} />}
        />
      ) : (
        <></>
      )}
      {ability.can("get", "orders") ? (
        <Route
          path={`${params}/orders/:orderId`}
          element={<ProtectedRoute component={Order} />}
        />
      ) : (
        <></>
      )}
      {ability.can("get", "stock") ? (
        <Route
          path={`${params}/stock`}
          element={<ProtectedRoute component={System} />}
        />
      ) : (
        <></>
      )}
      {ability.can("get", "products") ? (
        <Route
          path={getRouteByEnabledSystems("/products-portfolio/portfolio")}
          element={<ProtectedRoute component={ProductsPortfolio} />}
        />
      ) : (
        <></>
      )}
      {ability.can("metadata:get", "products") ? (
        <Route
          path={getRouteByEnabledSystems("/products-portfolio/metadata")}
          element={<ProtectedRoute component={Metadata} />}
        />
      ) : (
        <></>
      )}
      <Route
        path={`${params}/support`}
        element={<ProtectedRoute component={Support} />}
      />
      {ability.can("create", "orders") ? (
        <Route
          path={`${params}/store`}
          element={<ProtectedRoute component={Store} />}
        />
      ) : (
        <></>
      )}
      {ability.can("manage", "super") || ability.can("manage", "user") ? (
        <Route
          path={getRouteByEnabledSystems("/users")}
          element={<ProtectedRoute component={Users} />}
        />
      ) : (
        <></>
      )}
    </Switch>
  );
};
